import { ProductVideo } from 'components/ProductVideo';
import watchRecordingsLight from "../../../../contents/images/docs/session-replay/how-to-watch-recordings-light-mode.mp4";
import watchRecordingsDark from "../../../../contents/images/docs/session-replay/how-to-watch-recordings-dark-mode.mp4";
import createPlaylistLight from "../../../../contents/images/docs/session-replay/create-playlist-light-mode.mp4";
import createPlaylistDark from "../../../../contents/images/docs/session-replay/create-playlist-dark-mode.mp4";
import * as React from 'react';
export default {
  ProductVideo,
  watchRecordingsLight,
  watchRecordingsDark,
  createPlaylistLight,
  createPlaylistDark,
  React
};